import { jsx as e } from "@emotion/react/jsx-runtime";
import { StyledCell as m } from "./Cell.styled.js";
const f = ({
  children: o,
  className: s,
  colSpan: l,
  rowSpan: r,
  css: t
}) => /* @__PURE__ */ e(m, { className: s, colSpan: l, rowSpan: r, css: t, children: o });
export {
  f as Cell
};
